import { useQueries } from 'react-query';
import { client } from 'src/utils/api-client';
import { ProductImpactOutSchema } from '../LCADiagram/Diagram/index.types';

interface ProductEmissionData {
  productId: number;
  impact: ProductImpactOutSchema | null;
  isLoading: boolean;
  error: unknown;
}

export const useProductsEmissions = (
  productIds: number[],
  areaId: number | null
): { [productId: number]: ProductEmissionData } => {
  const queries = useQueries(
    productIds.map((productId) => ({
      queryKey: ['product-emissions', productId, areaId],
      queryFn: () =>
        areaId
          ? client
              .get<ProductImpactOutSchema>(
                `/web/lca/products/${productId}/impact/${areaId}`
              )
              .then((response) => response.data)
          : Promise.resolve(null),
      enabled: !!areaId && !!productId,
      staleTime: 5 * 60 * 1000, // 5 minutes
    }))
  );

  return productIds.reduce(
    (acc, productId, index) => {
      const query = queries[index];
      acc[productId] = {
        productId,
        impact: query.data || null,
        isLoading: query.isLoading,
        error: query.error,
      };
      return acc;
    },
    {} as { [productId: number]: ProductEmissionData }
  );
};
